import {
  ResourceType,
  SensorType,
  Site,
  Space,
  SentinelTarget,
  SentinelTargetType,
} from '@energybox/react-ui-library/dist/types';
import { Checkbox } from '@energybox/react-ui-library/dist/components';

import React from 'react';
import { fetchSpaces } from '../../../../actions/spacesFetch';
import ResourcePath from '../../../../containers/ResourcePath';
import { SpaceChip } from './TargetChips';
import styles from './StepRollout.module.css';

type Props = {
  site: Site;
  sensorTypes: SensorType[];
  selected: number[];
  handleTargetSelect: (sentinelTarget: SentinelTarget) => void;
  handleSetResourceRelation: (arg: number, arg2: number[]) => void;
};

type State = {
  spaces: Space[];
  isLoading: boolean;
};

class StepRolloutSpaces extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      spaces: [],
      isLoading: true,
    };
  }

  componentDidMount(): void {
    let dublicateSentinelkey = localStorage.getItem('duplicateSentinelKey');
    if (dublicateSentinelkey) {
      const { handleTargetSelect } = this.props;
      if (this.props.selected.length > 0) {
        handleTargetSelect({
          targetId: this.props.selected[0],
          targetType: SentinelTargetType.SPACE,
        });
      }
    }
    this.onLoad();
  }

  onLoad = async () => {
    this.setState({ isLoading: true });
    const { handleSetResourceRelation } = this.props;

    try {
      const { site, sensorTypes } = this.props;

      const spaces = await fetchSpaces({
        siteIds: [site.id],
        sensorTypes,
      });

      handleSetResourceRelation(
        site.id,
        spaces.map((e: Space) => e.id)
      );

      const sortedSpaces = spaces.sort((a, b) =>
        a.title.localeCompare(b.title)
      );

      this.setState({
        spaces: sortedSpaces,
        isLoading: false,
      });
    } catch (err) {
      this.setState({ isLoading: false });
    }
  };

  handleTargetSelectClick = (ev: any, item: any) => {
    const { handleTargetSelect } = this.props;
    ev.preventDefault();
    handleTargetSelect({
      targetId: item.id,
      targetType: SentinelTargetType.SPACE,
    });
  };

  render() {
    const { spaces = [], isLoading } = this.state;
    const { selected, site } = this.props;

    if (isLoading) {
      return <div className={styles.tableLoading}>Loading...</div>;
    }

    return (
      <div>
        <table className={styles.table}>
          <tbody>
            {spaces.length === 0 ? (
              <tr>
                <td colSpan={4}>
                  <div>This site has no spaces.</div>
                </td>
              </tr>
            ) : (
              spaces.map((item: Space) => (
                <tr
                  key={`renderSpaceRows${item.id}`}
                  onClick={ev => this.handleTargetSelectClick(ev, item)}
                  className={styles.filterRow}
                >
                  <td style={{ width: '30%' }}>
                    <SpaceChip id="generic" title={item.title} />
                  </td>
                  <td style={{ width: '55%' }}>
                    <ResourcePath
                      suppressLink
                      resourceId={item.id}
                      resourceType={ResourceType.SPACE}
                    />
                  </td>
                  <td className={styles.action} style={{ width: '15%' }}>
                    <Checkbox
                      checked={selected.includes(item.id)}
                      onChange={ev => this.handleTargetSelectClick(ev, item)}
                      id={`checkbox_${site.id}_${item.id}`}
                      size={16}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default StepRolloutSpaces;
